

@if (data === 2) {
  <div class="text-center">
    <img src="../../../assets/images/Loading/animation_500_kdqe72ts.gif" alt="" class="loadingWidht img-fluid">
  </div>
}

@if (data === 4) {
  <div style="display: flex; align-items: center; justify-content: center; ">
    <mat-spinner></mat-spinner>
  </div>
}
